export const environment = {
    production: false,
    appId: "disney.adgate",
    sessionTimeout: 7200,
    refreshTokenTimeout: 3600,
    baseUrl: "https://spots-qa.mediatwdcltam.com/",
    baseServiceUrl: "https://spots-qa.mediatwdcltam.com/adgate/rest/",
    asperaServiceUrl: "shares.mediatwdcltam.com",
    asperaAutoinstallLocation: "https://d3gcli72yxqn2z.cloudfront.net/connect/v4",
    myidAuthCodeUrl: "https://sso.myid.disney.com/oauth2/aus12rjp71ht7GjQl0x8/v1/authorize?client_id=ADGATE-QA&response_type=code&redirect_uri=https://spots-qa.mediatwdcltam.com/login&scope=openid+profile+email&state=[STATE]&code_challenge=[CODE_CHALLENGE]&code_challenge_method=s256",
    streamProxyUrl: "https://spots-qa.mediatwdcltam.com/adgate/rest/common/streamProxy/",
    helpCenterUrl: "https://spots-qa.mediatwdcltam.com/adgatehelpcenter/helpcenter.html",
  
    idHash: "NTkxYzg0NGZmNWQwNDNjYTllMDYxODBjODFlZmM5NDJhZjYxYmI4OGFlZGVkMmRhYjVlYTAyY2U1ZmQwMmNhNw=="
};
